import { styled } from '../../theme/styled'
import { TextareaAutosize } from '@mui/material'

const Textarea = styled(TextareaAutosize)`
  width: 100%;
  max-width: 100%;
  color: ${(p) => p.theme.av8.input.color};
  border-radius: 4px;
  background-color: ${(p) => p.theme.av8.background};
  border: 1px solid ${(p) => p.theme.av8.input.borderColor};
  width: 100%;
  resize: vertical;
  margin: 0;
  padding: 16px;
  box-sizing: border-box;
  font-family: ${(p) => p.theme.av8.typography.fontFamily};
  font-size: 14px;
  outline: none;
  &:focus {
    background-color: ${(p) => p.theme.av8.backgroundAlt};
    border: 2px solid ${(p) => p.theme.av8.input.color};
    padding: 15px;
  }
`

export default Textarea
